import CommonLandingContainer from '../../../../landingComponents/containers/common';
import styles from './serviceInfo.module.scss';
import {
  Heading1,
  Heading2,
  Title,
  SubTitle,
  Body,
  SmallText,
  SecondaryText,
  Info,
  Button,
  Heading3,
} from '../../../../landingComponents/typography';
import InfoPanel from '../../../../landingComponents/containers/infoPanel';
import AnimatedBox from 'src/components/landingComponents/containers/animatedScroll';
import { getClassName } from 'src/Core/utility/jsx';

const ServiceInfo = () => {
  return (
    <CommonLandingContainer >
      <AnimatedBox className={getClassName([styles.animatedBox])}>
        <Title accent>
          Наш сервис не заменяет консультацию врача и не ставит диагнозы
        </Title>
        <div className={styles.infoText}>
          <InfoPanel Header={() => <Body accent>Ламетри - помощник: </Body>}>
            <SecondaryText>
              Система создана, чтобы помочь вам разобраться в результатах
              анализов, обратить внимание на возможные проблемы и подсказать, к
              какому специалисту стоит обратиться, если это необходимо
            </SecondaryText>
          </InfoPanel>
          <InfoPanel
            Header={() => <Body accent>Работа с личными данными: </Body>}
          >
            <SecondaryText>
              Система не обрабатывает и не сохраняет ваши личные данные. ФИО и
              другая персональная информация не распознаются и не хранятся в
              нашей базе данных
            </SecondaryText>
          </InfoPanel>
        </div>
      </AnimatedBox>
    </CommonLandingContainer>
  );
};

export default ServiceInfo;
